import { render, staticRenderFns } from "./planosMensais.vue?vue&type=template&id=df1c1604"
import script from "./planosMensais.vue?vue&type=script&lang=js"
export * from "./planosMensais.vue?vue&type=script&lang=js"
import style0 from "./planosMensais.vue?vue&type=style&index=0&id=df1c1604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports